import React, { memo } from 'react';
import { Tooltip } from 'antd';
import { ReactComponent as FolderSvg } from '@assets/icons/folder.svg';
import { ReactComponent as PrivateFolderSvg } from '@assets/icons/folder-private.svg';
import TilesViewItem from './TilesViewItem';
import { AssetItemDto } from '@api/Api';
import { FolderWithItems } from '@pages/Campaigns/CampaignReview/utils';
import ActionFolder from '@pages/Campaigns/CampaignReview/components/Actions/ActionFolder';
import './TilesView.less';

type TilesViewProps = {
  onSelectFolder: (folderId: string) => void;
  onOpenAsset: (asset: AssetItemDto) => void;
  folders: FolderWithItems[];
  assetsList: AssetItemDto[];
  canManageReviews: boolean;
  reviewId: string;
};
export default memo(function TilesView({
  onSelectFolder,
  onOpenAsset,
  folders,
  assetsList,
  canManageReviews,
  reviewId
}: TilesViewProps) {
  return (
    <div className="campaign-review-tiles-view">
      {!!folders?.length && (
        <div className="campaign-review-tiles-view-folders">
          <div className="campaign-review-tiles-view-label">Folders</div>
          <div className="campaign-review-tiles-view-folders-list">
            {folders.map((folder) => {
              const assetsToDownload = folder.items.filter(
                (asset) => !!asset.asset?.permissions.download
              );
              return (
                <div
                  className="campaign-review-tiles-view-folder"
                  key={folder.id}
                  onClick={() => onSelectFolder(folder.id)}
                >
                  {folder.isPrivate ? <PrivateFolderSvg /> : <FolderSvg />}
                  <div className="campaign-review-tiles-view-folder-name">
                    <Tooltip
                      title={folder.name}
                      overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                    >
                      {folder.name}
                    </Tooltip>
                  </div>
                  <ActionFolder
                    canManageReviews={canManageReviews}
                    assets={assetsToDownload}
                    folderName={folder.name}
                    reviewId={reviewId}
                    folderId={folder.id}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!!assetsList?.length && (
        <div className="campaign-review-tiles-view-assets">
          <div className="campaign-review-tiles-view-label">Media</div>
          <div className="campaign-review-tiles-view-assets-list">
            {assetsList.map((item) => {
              return (
                <TilesViewItem
                  key={item.id}
                  asset={item}
                  onOpenAsset={onOpenAsset}
                  canManageReviews={canManageReviews}
                  reviewId={reviewId}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
});
